<template>
  <ul v-if="active" class="fl-mobile">
    <slot />
  </ul>
</template>
<script>
export default {
  name: 'DropdownContent',
  inject: ["sharedState"],
  computed: {
    active() {
      return this.sharedState.active;
    }
  }
}
</script>
<style>
  /*MENU MOBILE*/
  .logo-mobile {
      padding-bottom: 4vh;
      padding-left: 10px;
  }
  img {
      vertical-align: middle;
  }
  .overlay {
      height: 100%;
      width: 100%;
      position: fixed;
      z-index: 99999999999999;
      top: 0;
      left: 0;
      background-color: rgb(255, 255, 255);
      overflow-x: hidden;
      transition: 0.5s;
  }
  .overlay-content-container {
      background: #ffffff;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 100000;
      font-family: 'Raleway', sans-serif;
  }
  .overlay-content {
    padding-left: 30px;
  }
  a.closeBtn {
      position: absolute;
      top: 20px;
      right: 45px;
      font-size: 60px;
      font-weight: bold;
      color: #000000;
      text-decoration: none;
      font-family: 'Raleway', sans-serif;
  }
  a.closeBtn:active,
  a.closeBtn:visited {
    color: #000000;
    opacity: 1;
  }
  .overlay-content a,
  .overlay-content p {
      padding: 8px;
      text-decoration: none;
      font-size: 14px;
      line-height: 24px;
      font-weight: bold;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      color: #000000;
      display: block;
      transition: 0.3s;
  }
  .social-buttons-mobile {
      display: flex;
  }
  .menu-link span i {
    margin-left: 5px;
    font-size: 20px;
    color: #F4CC0B;
  }
  .fl-mobile {
      padding-left: 20px;
      list-style-type: none;
      margin-bottom: 0;
  }
  .navMob {
    z-index: 100000;
    display: none;
  }
  .open {
    display: block;
  }

  @media(max-width: 1255px) {
    .logo-text {
      margin-top: 5px;
    }
  }
  </style>
